import AddNewPrescription from '@components/pdp-contacts-prescriptions/my-new-prescription/AddNewPrescription';
import { getLabelFallback } from '@utils/utils';

const GuestUserPage = () => {
    return (
        <div className="presc-tab-selection guest-tab">
            <div className="presc-tab select-presc-guest active">{getLabelFallback('CONTACT_LENSES_SUPPLY_TITLE')}</div>
            <AddNewPrescription />
        </div>
    );
};

export default GuestUserPage;
